import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

const navigationSlice = createSlice({
  name: 'navigation',
  initialState,
  reducers: {
    openCashier() { /* do nothing */ },
    goHome() { /* do nothing */ },
    openTable() { /* do nothing */ },
  },
});

export const navigation = navigationSlice.actions;
export default navigationSlice.reducer;
